import React, { useEffect } from 'react'
import {
  Image,
  Link,
  RichText,
  isEditorActive,
} from '@sitecore-jss/sitecore-jss-react'
import { SimpleCardListProps } from './types/SimpleCardList.types'
import './index.scss'

import { anchorWithId } from '../../helpers/anchorWithId.helper'
import { LinkField } from '../../types/types'

const SimpleCardList = (props: SimpleCardListProps) => {
  const SimpleCardList = props.fields?.['Cards list']
  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <div className="simpleCardListWrapper">
      {props.fields && SimpleCardList && (
        <div className="simplecard-lists" id={props?.rendering?.uid}>
          {SimpleCardList.map((item, index) => {
            return (
              <div className="simplecard-lists-full" key={index}>
                <div className="simplecard-lists-full__image--wrapper">
                  <Image
                    loading="lazy"
                    field={item?.fields?.Image}
                    className="simplecard-lists-full__image desktopImage"
                  />
                  <Image
                    loading="lazy"
                    field={
                      item?.fields?.ImageMobile &&
                      Object.keys(item?.fields?.ImageMobile?.value ?? []).length > 0
                        ? item?.fields?.ImageMobile
                        : (item?.fields?.AllowFallbackForMobile?.value ?
                          item?.fields?.Image : undefined)
                    }
                    className="simplecard-lists-full__image mobileImage"
                  />
                </div>
                <div className="simplecard-lists-full__content">
                  <div className="simplecard-lists-full__content__header">
                    <RichText
                      className=" simplecard-lists-full__title"
                      field={item?.fields?.Title}
                      tag="div"
                    />
                    <RichText
                      className=" simplecard-lists-full__description"
                      field={item?.fields?.Description}
                      tag="h3"
                    />
                  </div>

                  <div className="simplecard-lists-full__footer">
                    {isEditorActive() ? (
                      <Link field={item.fields?.GeneralLink as LinkField} />
                    ) : (
                      <a
                        href={anchorWithId(
                          item?.fields?.GeneralLink?.value?.href ?? '',
                          item.fields?.GeneralLink?.value?.anchor
                        )}
                        className="simplecard-lists-full__generallink"
                        target="_self"
                      >
                        {item.fields?.GeneralLink?.value?.text}
                        <span className="link-with-arrow link-with-arrow--text">
                          <pfe-icon
                            icon="cnh-arrow-forward"
                            size={'24'}
                            color={'complement'}
                          />
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default SimpleCardList
